import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { IResetPassword } from "../../../interfaces/auth/IResetPassword";
import Button from "../../../shared/button";
import Error from "../../../shared/error";
import Input from "../../../shared/input";
import { useResetPasswordMutation } from "../../../store/user/userDomApi";
import SuccessResetModal from "./modals/SuccessResetModal";

type FormValues = {
    username: string;
    newPassword: string;
    confirmNewPassword: string;
    confirmationCode: string;
};

const ResetPassword = () => {
    const { token } = useParams()
    const [generalError, setGeneralError] = useState<string>()
    const [resetPasswordMutation, { isLoading, error }] = useResetPasswordMutation()
    const [successModal, setSuccessModal] = useState<boolean>(false)
    const navigate = useNavigate()

    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        reset,
        watch
    } = useForm<FormValues>({});

    const onSubmit = async (data: FormValues) => {
        try {
            const payload: IResetPassword = {
                username: data?.username,
                password: data?.newPassword,
                confirmationCode: data?.confirmationCode
            }
            const response = await resetPasswordMutation(payload).unwrap()
            setGeneralError(undefined)
            setSuccessModal(true)
            reset()
        } catch (err) {
            setGeneralError(`${err}`)
        }
    }

    return (
        <div className="md:min-h-screen px-10 py-12">
            <NavLink to="/">
                {/* Logo here */}
                {/* <img className="max-w-[290px]" alt="for the earth" src="/logo/logo.svg" /> */}
            </NavLink>
            <div className="max-w-[330px] m-auto mt-[9%]">
                <h1 className="font-dm_sans_bold text-4xl text-center mb-5">Please write your new password</h1>
                {generalError && <Error text={generalError} />}
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Input
                        placeholder="Username"
                        register={register('username', {
                            required: {
                                message: 'Username is required',
                                value: true,
                            },
                            validate: (value: string) => !!value.trim() || 'Username is required'
                        })}
                        error={errors.username?.message}
                    />
                    <Input
                        placeholder="New Password"
                        type={'password'}
                        register={register('newPassword', {
                            required: {
                                message: 'Password is required',
                                value: true,
                            },
                            minLength: {
                                value: 8,
                                message: "Minimum number of characters is 8"
                            },
                            pattern: {
                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                message: "Password should be at least 8 characters long, and must contain at least 1 number, 1 lower case, 1 upper case and 1 special character"
                            },
                            validate: (value: string) => !!value.trim() || 'New Password is required and min length is 8'
                        },
                        )}
                        error={errors.newPassword?.message}
                    />
                    <Input
                        placeholder="Repeat Password"
                        type={'password'}
                        register={register('confirmNewPassword', {
                            required: {
                                message: 'Repeat password is required',
                                value: true,
                            },
                            validate: (val: string) => {
                                if (watch('confirmNewPassword') !== val) {
                                    return "Repeat password do not match";
                                }
                            }
                        })}
                        error={errors.confirmNewPassword?.message}
                    />
                    <Input
                        placeholder="Confirmation Code"
                        register={register('confirmationCode', {
                            required: {
                                message: 'Confirmation Code is required',
                                value: true,
                            },
                            validate: (value: string) => !!value.trim() || 'Confirmation Code is required'

                        })}
                        error={errors.confirmNewPassword?.message}
                    />
                    <Button
                        label={'Reset Password'}
                        className={'btn-primary-rounded-less min-w-full my-2 !py-2'}
                        type={'submit'}
                    />

                </form>
                <SuccessResetModal
                    openModal={successModal}
                    handleCloseModal={() => setSuccessModal(false)}
                />
            </div>

        </div>
    )
}

export default ResetPassword;